import { GTM_BODY_CLASSES } from '@aca-new/app/shared/constants/gtm-analytics.constants';
import { ELoginType } from '@aca-new/app/shared/models/enums/login-type.enum';
import { AppOverlayService } from '@aca-new/app/shared/services/modal-services/app-overlay/app-overlay.service';
import { AppAuthenticationService } from '@aca-new/app/shared/services/user-services/app-authentication/app-authentication.service';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'app-my-qima',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  public isLoading: boolean = false;

  public constructor(
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _appOverlayService: AppOverlayService,
    private readonly _appAuthenticationService: AppAuthenticationService,
    private readonly _router: Router,
    private readonly _renderer: Renderer2,
    @Inject(DOCUMENT) private readonly _document: Document
  ) {}

  public ngOnInit(): void {
    this._watch();
    this._syncLoginFromBackOfficeMarker();
  }

  private _watch(): void {
    this._appOverlayService.isLoading$.pipe(untilDestroyed(this)).subscribe((isLoading: boolean): void => {
      this.isLoading = isLoading;
      this._changeDetectorRef.detectChanges();
    });

    this._router.events
      .pipe(
        filter((event): boolean => event instanceof NavigationEnd),
        untilDestroyed(this)
      )
      .subscribe((): void => {
        this._syncLoginFromBackOfficeMarker();
      });
  }

  /**
   * Keeps the GTM body marker in sync with the current session login type.
   * Runs on every navigation because back-office login lands through an in-app
   * redirect, so the login type cookie is not yet set when the app boots.
   */
  private _syncLoginFromBackOfficeMarker(): void {
    const { loginType } = this._appAuthenticationService.getAuthenticationData();

    if (loginType === ELoginType.LOGIN_FROM_SSO) {
      this._renderer.addClass(this._document.body, GTM_BODY_CLASSES.loginFromBackOffice);

      return;
    }

    this._renderer.removeClass(this._document.body, GTM_BODY_CLASSES.loginFromBackOffice);
  }
}
